import React, { useState, useEffect } from 'react';

import App from './index';
import AppNavigator from './navigation/AppNavigator';

export default function AppParents() {
    return <App appType={'pennygem'} navigator={AppNavigator} />;
}
